import React from "react";
import PropTypes from 'prop-types';

import ReactDOM from "react-dom";
import { connect } from 'react-redux';
import { traducirPagina, obtenerUsuario, obtenerToken, obtenerFechaLocalObjeto, convertirCodigoAMeses } from "../../librerias/funciones";
import { ObtenerConfiguracionMensajeriaEnAPI, GetEstadisticasTotalesAnnosEnAPI } from "../../action/actionCreatorsRequests";
import { CPCard } from "../../components/Utils/Card/CPCard"
import { Select } from "antd";
import { CPSwitch } from "../Utils/Switch/CPSwitch";
import {
    MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem
} from 'mdbreact';
import { CPProgress } from "../Utils/Progess/CPProgress";

const { Option } = Select;
const PageMatricula = () => {
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)

    const [sociosLocal, setSociosLocal] = React.useState([]);
    const [socioSeleccionado, setSocioSeleccionado] = React.useState(0);

    const [mesesDelAnio, setMesesDelAnio] = React.useState(
        [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
        ]
    );
    const [mesSeleccionado, setMesSeleccionado] = React.useState("")
    const [anios, setAnios] = React.useState([]);
    const [anioSeleccionado, setAnioSeleccionado] = React.useState("")

    const [seCambioElDia, setSeCambioElDia] = React.useState(true);
    const [seCambioElMes, setSeCambioElMes] = React.useState(false);
    const [seCambioElAnio, setSeCambioElAnio] = React.useState(false);




    const buscarAnios = (socio, codigoMes, Anio) => {
        let fechaLocal = obtenerFechaLocalObjeto(false);
        let crearFecha = fechaLocal.DIA + "/" + codigoMes + "/" + Anio

        GetEstadisticasTotalesAnnosEnAPI(crearFecha, "0", "0", socio).then((registros) => {
            if (registros.REGISTROS !== undefined && registros.REGISTROS !== null && registros.REGISTROS.length > 0) {
                setAnios(registros.REGISTROS)
            } else {
                setAnios(null)
            }
        })
    }


    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })

    React.useEffect(() => {
        if (obtenerToken() !== undefined) {
            let accesoLicencia = obtenerUsuario();
            setSociosLocal(accesoLicencia.SOCIOS)
            //ObtenerConfiguracionMensajeria(accesoLicencia.SOCIOS[0].ID_SOCIO)
            setSocioSeleccionado(accesoLicencia.SOCIOS[0].ID_SOCIO)

            let fechaLocal = obtenerFechaLocalObjeto(false);
            setMesSeleccionado(convertirCodigoAMeses(fechaLocal.MES))
            setAnioSeleccionado(fechaLocal.ANIO)
            buscarAnios(accesoLicencia.SOCIOS[0].ID_SOCIO, fechaLocal.MES, fechaLocal.ANIO)

        }
    }, [])



    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {`NEXT ASSIST - ${traducirPagina("Matriculas")}`}
        </>,
        document.getElementById("tituloMenu")
    );



    return (
        <div>
            <div className="menu_mantenimiento" ref={ref}>

                <div className="mantenimiento_item1">
                    <div>
                        {sociosLocal !== null ?
                            <Select
                                showSearch
                                allowClear={obtenerUsuario().SOCIOS.length > 1 ? true : false}
                                defaultValue={obtenerUsuario() !== null ? obtenerUsuario().SOCIOS[0].ID_SOCIO : ""}
                                size={"large"}
                                placeholder={traducirPagina("Seleccione_socio")}
                                style={{ width: "400px", textAlign: 'left' }}
                                optionFilterProp="children"
                                onChange={(e) => {
                                    if (e === undefined || e === null) {
                                        setSocioSeleccionado(0)
                                    } else {
                                        setSocioSeleccionado(parseInt(e));
                                        //ObtenerConfiguracionMensajeria(parseInt(e))
                                    }
                                }}
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {sociosLocal.length > 0 ?
                                    sociosLocal.map((socio) =>
                                        <Option key={socio.ID_SOCIO} value={socio.ID_SOCIO}>{socio.NOMBRE_SOCIO}</Option>
                                    )
                                    :
                                    null
                                }
                            </Select>
                            :
                            <div style={{ textAlign: 'center' }}>
                                <h4>{traducirPagina("Info_error_socio")}</h4>
                            </div>
                        }
                    </div>
                </div>

                <div className="mantenimiento_item2">
                    <div style={{ padding: '8px 20px', backgroundColor: seCambioElDia ? '#00468e' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff', textAlign: 'center', borderRadius: '4px 0px 0px 4px' }}
                        onClick={(e) => {
                            let anioActual = obtenerFechaLocalObjeto(false).ANIO;
                            setAnioSeleccionado(anioActual);

                            setSeCambioElDia(true);
                            setSeCambioElMes(false);
                            setSeCambioElAnio(false);
                            //anioSeleccionado
                            //buscarEstadisticasMatriculas(socioSeleccionado, obtenerFechaLocalObjeto(false).MES, anioActual, { DESDE: "4", HASTA: "5" });
                            //buscarEstadisticasMatriculasGrupo(0, obtenerFechaLocalObjeto(false).MES, anioActual, { DESDE: "4", HASTA: "5" });

                        }}>
                        {traducirPagina("Hoy").toUpperCase()}
                    </div>

                    <MDBDropdown>
                        <MDBDropdownToggle nav>
                            <div style={{ padding: '8px 20px', backgroundColor: seCambioElMes ? '#00468e' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff' }}>
                                {mesSeleccionado.toUpperCase()}
                            </div>
                        </MDBDropdownToggle>

                        <MDBDropdownMenu right >
                            {mesesDelAnio.map((mes, i) =>
                                <MDBDropdownItem key={i} onClick={(e) => {
                                    setSeCambioElDia(false);
                                    setSeCambioElAnio(false);
                                    setMesSeleccionado(e.target.innerText);

                                    //buscarEstadisticasMatriculas(socioSeleccionado, convertirAMesACodigo(e.target.innerText), anioSeleccionado, { DESDE: "0", HASTA: "1" });
                                    //buscarEstadisticasMatriculasGrupo(0, convertirAMesACodigo(e.target.innerText), anioSeleccionado, { DESDE: "0", HASTA: "1" });
                                    setSeCambioElMes(true)
                                }}>  {mes.toUpperCase()}</MDBDropdownItem>
                            )}
                        </MDBDropdownMenu>
                    </MDBDropdown>


                    <MDBDropdown>
                        <MDBDropdownToggle nav>
                            <div style={{ padding: '8px 20px', backgroundColor: seCambioElAnio ? '#00468e' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff', borderRadius: '0px 4px 4px 0px' }}>
                                {anioSeleccionado}
                            </div>
                        </MDBDropdownToggle>


                        <MDBDropdownMenu right >
                            {anios !== null ?
                                anios.map((anio, i) =>
                                    <MDBDropdownItem key={i} onClick={(e) => {
                                        setSeCambioElDia(false);
                                        setSeCambioElMes(false);
                                        setAnioSeleccionado(e.target.innerText);

                                        //buscarEstadisticasMatriculas(socioSeleccionado, convertirAMesACodigo(mesSeleccionado), e.target.innerText, { DESDE: "2", HASTA: "3" });
                                        //buscarEstadisticasMatriculasGrupo(0, convertirAMesACodigo(mesSeleccionado), e.target.innerText, { DESDE: "2", HASTA: "3" });
                                        setSeCambioElAnio(true)
                                    }}>  {anio.ANYO}</MDBDropdownItem>
                                )
                                :
                                null
                            }
                        </MDBDropdownMenu>
                    </MDBDropdown>


                </div>

            </div>



            <div className="margen_tabla">
                <div className="container_tabla_generico" style={{ height: `calc(100vh - ${(150 + alturaSubmenu)}px )` }}>
                    <div className="grid_template">
                        <CPCard>

                            <div className="menu_mantenimiento header_progress">
                                <div className="mantenimiento_item1">
                                    {traducirPagina("Consulta_grupo")}
                                </div>
                                <div className="mantenimiento_item2">
                                    45.000
                                </div>
                            </div>

                            <CPProgress
                                registros={[{
                                    PORCENTAJE: 80,
                                    DESCRIPCION: "OK",
                                    TOTAL: "11.092"
                                }, {
                                    PORCENTAJE: 40,
                                    DESCRIPCION: "KO",
                                    TOTAL: "5.000"
                                }]
                                }
                            >
                            </CPProgress>
                        </CPCard>

                        <CPCard>
                            <div>
                                Pruebas 2
                            </div>
                        </CPCard>
                    </div>

                </div>
            </div>

        </div>
    )
}


PageMatricula.propTypes = {
};


const mapStateToProps = (state, props) => {
    return {
        props: props
    };
}

export default connect(mapStateToProps)(PageMatricula);